import { render, staticRenderFns } from "./parsingList.vue?vue&type=template&id=068b4d3e&scoped=true"
import script from "./parsingList.vue?vue&type=script&lang=js"
export * from "./parsingList.vue?vue&type=script&lang=js"
import style0 from "./parsingList.vue?vue&type=style&index=0&id=068b4d3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b4d3e",
  null
  
)

export default component.exports